import React, { useState, useEffect } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import WishlistTour from "./wishlist-tour";
import { tourService } from "../../services/tourService";

import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const Wishlist = () => {
  const { user } = useSelector((state) => state.auth);
  const { userInfo } = useSelector((state) => state.user);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistTours, setWishlistTours] = useState([]);
  const [uploading, setUploading] = useState(false);
  var userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  } else {
    userId = 0;
  }

  useEffect(() => {
    const fetchWishlistTours = async () => {
      setUploading(true);
      if (!user) {
        setWishlistTours([]); // Xóa danh sách tour khi người dùng đăng xuất hoặc wishlist rỗng.
        setUploading(false);
        return;
      }

      const wishlistExist =
        JSON.parse(localStorage.getItem(`wishlist_${userId}`)) || [];

      if (wishlistExist.length === 0) {
        setWishlistTours([]);
        setUploading(false);
        toast.info("Danh sách tour yêu thích của bạn hiện đang trống.");
        return;
      }

      setWishlist(wishlistExist);

      try {
        // Gọi service để lấy danh sách tour từ backend
        const response = await tourService.getToursByIds(wishlistExist);
        const allTours = response.data;

        setWishlistTours(allTours);
      } catch (error) {
        console.error("Lỗi khi lấy danh sách tour cho wishlist:", error);
      }
      setUploading(false);
    };

    fetchWishlistTours();
  }, []);

  // Hàm xử lý khi click vào tour (cập nhật wishlist)
  const toggleWishlist = (tourId) => {
    let updatedWishlist;

    if (wishlist.includes(tourId)) {
      updatedWishlist = wishlist.filter((id) => id !== tourId); // Xóa khỏi wishlist
      toast.info("Đã xóa khỏi danh sách yêu thích");
    } else {
      updatedWishlist = [...wishlist, tourId]; // Thêm vào wishlist
      toast.success("Đã thêm vào danh sách yêu thích");
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(`wishlist_${userId}`, JSON.stringify(updatedWishlist));
    window.dispatchEvent(new Event("wishlistUpdated")); // Phát sự kiện
  };

  return (
    <>
      {userInfo && (
        <div className="content">
          <div className="container">
            <div className="row">
              {/* <!-- Sidebar --> */}
              <Sidebar page="wishlist" />
              {/* <!-- /Sidebar --> */}

              <div className="col-xl-9 col-lg-8">
                <div className="card">
                  <div className="card-body">
                    <h6>Danh sách yêu thích của tôi</h6>
                    <p className="fs-14">
                      Số tour trong danh sách yêu thích : {wishlist.length}
                    </p>
                  </div>
                </div>
                {uploading && (
                  <LoadingSpinner
                    type="circle"
                    color="#3498db"
                    size={30}
                    text="Đang tải tour du lịch..."
                  />
                )}
                {wishlistTours.length > 0 ? (
                  wishlistTours.map((tour) => (
                    <WishlistTour
                      key={tour.tourId}
                      tourId={tour.tourId}
                      tour={tour}
                      onToggleWishlist={toggleWishlist}
                      isWishlisted={wishlist.includes(tour.tourId)}
                      userInfo={userInfo}
                    />
                  ))
                ) : (
                  <p>Không có tour nào trong wishlist.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
    // <!-- Page Wrapper -->
  );
};

export default Wishlist;
